import update from "immutability-helper";
import { ResponseActionTypes, ResponsesAction, ResponseVersionsActionTypes, ResponseVersionsAction } from "./Actions";
import { IResponsesState, IResponseVersionsState } from "./Models";

const initialState: IResponsesState = {
  failed: false,
  fetched: false,
  fetching: false,
  error: '',
  responses: {
    firstRowOnPage: 0,
    lastRowOnPage: 10,
    pageCount: 0,
    pageSize: 10,
    rowCount: 0,
    currentPage: 1,
    sortOrder: '',
    results: []
  },
  orderBy: 'dateModified desc'
};

const initialVersionsState: IResponseVersionsState = {
  failed: false,
  fetched: false,
  fetching: false,
  error: '',
  responses: {
    versions: [],
    resourceNotFound: false,
    errors: [],
    hasErrors: false
  }
};

export const ResponsesReducer = (
  state = initialState,
  action: ResponsesAction
): IResponsesState => {
  switch (action.type) {
    case ResponseActionTypes.FetchResponsesPending:
      return update(state, {
        fetched: { $set: false },
        fetching: { $set: true },
        failed: { $set: false },
        error: { $set: '' }
      });
    case ResponseActionTypes.FetchResponsesRejected:
      return update(state, {
        responses: { $set: { ...initialState.responses } },
        error: { $set: action.payload.error },
        fetched: { $set: false },
        fetching: { $set: false },
        failed: { $set: true }
      });
    case ResponseActionTypes.FetchedResponses:
      return update(state, {
        fetched: { $set: true },
        fetching: { $set: false },
        failed: { $set: false },
        error: { $set: '' },
        responses: { $set: { ...action.payload.responses } }
      });
    case ResponseActionTypes.SetSortOrder:
      return update(state, {
        orderBy: { $set: action.payload.orderBy }
      });
    case ResponseActionTypes.ResetSortOrder:
      return update(state, {
        orderBy: { $set: initialState.orderBy }
      });
    default:
      return state;
  }
}

export const ResponseVersionsReducer = (
  state = initialVersionsState,
  action: ResponseVersionsAction
): IResponseVersionsState => {
  switch (action.type) {
    case ResponseVersionsActionTypes.FetchResponseVersionsPending:
      return update(state, {
        fetched: { $set: false },
        fetching: { $set: true },
        failed: { $set: false },
        error: { $set: '' }
      });
    case ResponseVersionsActionTypes.FetchResponseVersionsRejected:
      return update(state, {
        responses: { $set: initialVersionsState.responses },
        error: { $set: action.payload.error },
        fetched: { $set: false },
        fetching: { $set: false },
        failed: { $set: true }
      });
    case ResponseVersionsActionTypes.FetchedResponseVersions:
      return update(state, {
        fetched: { $set: true },
        fetching: { $set: false },
        failed: { $set: false },
        error: { $set: '' },
        responses: { $set: action.payload.responses }
      });
    case ResponseVersionsActionTypes.ResetResponseVersions:
      return initialVersionsState;
    default:
      return state;
  }
}
